import { render, staticRenderFns } from "./QuestionnaireEditQuestion.vue?vue&type=template&id=5b3d0c44&"
import script from "./QuestionnaireEditQuestion.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireEditQuestion.vue?vue&type=script&lang=js&"
import style0 from "./QuestionnaireEditQuestion.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports